'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var dist = {};

Object.defineProperty(dist, '__esModule', {
  value: true
});

/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 判断是否是Tms环境(项目终止了)
 */
function isTms() {
  // @ts-ignore
  const {
    isTms
  } = window.jusdaBaseConfig;
  return isTms;
}
var isTms_1 = dist.isTms = isTms;

const juslinkTheme$1 = {
  primaryColor: '#ffc500',
  infoColor: '#ffc500',
  successColor: '#6fc677',
  errorColor: '#ff6c6c',
  processingColor: '#ffc500',
  warningColor: '#ffc500'
};
const foxconnTheme$1 = {
  primaryColor: '#2755a6',
  infoColor: '#4096ff',
  successColor: '#6fc677',
  errorColor: '#ff6c6c',
  processingColor: '#2755a6',
  warningColor: '#2755a6'
};
function getAntdTheme$1() {
  const antdTheme = isTms_1() ? foxconnTheme$1 : juslinkTheme$1;
  return antdTheme;
}

const juslinkTheme = {
  'colorPrimary': '#ffc500',
  'colorPrimaryBg': '#FFF8D9',
  'colorSuccess': '#6fc677',
  'colorError': '#ff6c6c',
  'colorPrimaryHover': '#FFDA39',
  'colorBgLayout': '#F2F2F2',
  'colorPrimaryBorder': '#fcbe5b',
  'colorPrimaryBorderHover': '#fa8c16',
  'colorPrimaryActive': '#FFE366',
  'colorPrimaryBgHover': '#FFDA39',
  'colorInfo': '#ffc500'
};
const foxconnTheme = {
  'colorPrimary': '#2755a6',
  'colorPrimaryBg': '#e1edf4',
  'colorSuccess': '#52c41a',
  'colorError': '#ff3352',
  'colorPrimaryHover': '#1677ff',
  'colorBgLayout': '#EAF0F5',
  'colorPrimaryBorder': '#3e89d4',
  'colorPrimaryBorderHover': '#1677ff',
  'colorPrimaryActive': '#599eff'
};
function getAntdTheme() {
  const antdTheme = isTms_1() ? foxconnTheme : juslinkTheme;
  return antdTheme;
}

/* eslint-disable @typescript-eslint/explicit-function-return-type */
function getAntdConfig(version) {
  return version === 'v5' ? getAntdTheme() : getAntdTheme$1();
}

var juslinkPackagecssVariables = {
  '--juslink-primary-color': 'rgb(255, 197, 0)',
  '--juslink-primary-color-disabled': '#fff6a3',
  '--juslink-primary-color-hover': '#ffd429',
  '--juslink-primary-color-active': '#d99f00',
  '--juslink-primary-color-outline': 'rgba(255, 197, 0, 0.2)',
  '--juslink-primary-color-deprecated-bg': '#fffde6',
  '--juslink-primary-color-deprecated-border': '#ffed7a',
  '--juslink-primary-1': '#fffde6',
  '--juslink-primary-2': '#fff6a3',
  '--juslink-primary-3': '#ffed7a',
  '--juslink-primary-4': '#ffe252',
  '--juslink-primary-5': '#ffd429',
  '--juslink-primary-6': '#ffc500',
  '--juslink-primary-7': '#d99f00',
  '--juslink-primary-8': '#b37d00',
  '--juslink-primary-9': '#8c5e00',
  '--juslink-primary-10': '#664100',
  '--juslink-primary-color-deprecated-l-35': 'rgb(255, 238, 179)',
  '--juslink-primary-color-deprecated-l-20': 'rgb(255, 220, 102)',
  '--juslink-primary-color-deprecated-t-20': 'rgb(255, 209, 51)',
  '--juslink-primary-color-deprecated-t-50': 'rgb(255, 226, 128)',
  '--juslink-primary-color-deprecated-f-12': 'rgba(255, 197, 0, 0.12)',
  '--juslink-primary-color-active-deprecated-f-30': 'rgba(255, 253, 230, 0.3)',
  '--juslink-primary-color-active-deprecated-d-02': 'rgb(255, 252, 220)',
  '--juslink-success-color': 'rgb(111, 198, 119)',
  '--juslink-success-color-disabled': '#ebfaeb',
  '--juslink-success-color-hover': '#98d49c',
  '--juslink-success-color-active': '#52a15c',
  '--juslink-success-color-outline': 'rgba(111, 198, 119, 0.2)',
  '--juslink-success-color-deprecated-bg': '#f1fff0',
  '--juslink-success-color-deprecated-border': '#dfeddf',
  '--juslink-warning-color': 'rgb(255, 197, 0)',
  '--juslink-warning-color-disabled': '#fff6a3',
  '--juslink-warning-color-hover': '#ffd429',
  '--juslink-warning-color-active': '#d99f00',
  '--juslink-warning-color-outline': 'rgba(255, 197, 0, 0.2)',
  '--juslink-warning-color-deprecated-bg': '#fffde6',
  '--juslink-warning-color-deprecated-border': '#ffed7a',
  '--juslink-error-color': 'rgb(255, 108, 108)',
  '--juslink-error-color-disabled': '#fff2f0',
  '--juslink-error-color-hover': '#ff9794',
  '--juslink-error-color-active': '#d95055',
  '--juslink-error-color-outline': 'rgba(255, 108, 108, 0.2)',
  '--juslink-error-color-deprecated-bg': '#fff2f0',
  '--juslink-error-color-deprecated-border': '#ffe8e6',
  '--juslink-info-color': 'rgb(98, 148, 198)',
  '--juslink-info-color-disabled': '#ebf4fa',
  '--juslink-info-color-hover': '#8ab1d4',
  '--juslink-info-color-active': '#4771a1',
  '--juslink-info-color-outline': 'rgba(98, 148, 198, 0.2)',
  '--juslink-info-color-deprecated-bg': '#f0faff',
  '--juslink-info-color-deprecated-border': '#dfe7ed'
};

var foxconnPackagecssVariables = {
  '--juslink-primary-color': 'rgb(39, 85, 166)',
  '--juslink-primary-color-disabled': '#bdcbd9',
  '--juslink-primary-color-hover': '#4671b3',
  '--juslink-primary-color-active': '#173a80',
  '--juslink-primary-color-outline': 'rgba(39, 85, 166, 0.2)',
  '--juslink-primary-color-deprecated-bg': '#d8dfe6',
  '--juslink-primary-color-deprecated-border': '#91accc',
  '--juslink-primary-1': '#d8dfe6',
  '--juslink-primary-2': '#bdcbd9',
  '--juslink-primary-3': '#91accc',
  '--juslink-primary-4': '#698ebf',
  '--juslink-primary-5': '#4671b3',
  '--juslink-primary-6': '#2755a6',
  '--juslink-primary-7': '#173a80',
  '--juslink-primary-8': '#0c2359',
  '--juslink-primary-9': '#041133',
  '--juslink-primary-10': '#01040d',
  '--juslink-primary-color-deprecated-l-35': 'rgb(153, 181, 231)',
  '--juslink-primary-color-deprecated-l-20': 'rgb(91, 136, 216)',
  '--juslink-primary-color-deprecated-t-20': 'rgb(82, 119, 184)',
  '--juslink-primary-color-deprecated-t-50': 'rgb(147, 170, 211)',
  '--juslink-primary-color-deprecated-f-12': 'rgba(39, 85, 166, 0.12)',
  '--juslink-primary-color-active-deprecated-f-30': 'rgba(216, 223, 230, 0.3)',
  '--juslink-primary-color-active-deprecated-d-02': 'rgb(210, 218, 226)',
  '--juslink-success-color': 'rgb(64, 150, 255)',
  '--juslink-success-color-disabled': '#e3f3ff',
  '--juslink-success-color-hover': '#69b1ff',
  '--juslink-success-color-active': '#2b74d9',
  '--juslink-success-color-outline': 'rgba(64, 150, 255, 0.2)',
  '--juslink-success-color-deprecated-bg': '#f0f9ff',
  '--juslink-success-color-deprecated-border': '#bae0ff',
  '--juslink-warning-color': 'rgb(39, 85, 166)',
  '--juslink-warning-color-disabled': '#bdcbd9',
  '--juslink-warning-color-hover': '#4671b3',
  '--juslink-warning-color-active': '#173a80',
  '--juslink-warning-color-outline': 'rgba(39, 85, 166, 0.2)',
  '--juslink-warning-color-deprecated-bg': '#d8dfe6',
  '--juslink-warning-color-deprecated-border': '#91accc',
  '--juslink-error-color': 'rgb(64, 150, 255)',
  '--juslink-error-color-disabled': '#e3f3ff',
  '--juslink-error-color-hover': '#69b1ff',
  '--juslink-error-color-active': '#2b74d9',
  '--juslink-error-color-outline': 'rgba(64, 150, 255, 0.2)',
  '--juslink-error-color-deprecated-bg': '#f0f9ff',
  '--juslink-error-color-deprecated-border': '#bae0ff',
  '--juslink-info-color': 'rgb(64, 150, 255)',
  '--juslink-info-color-disabled': '#e3f3ff',
  '--juslink-info-color-hover': '#69b1ff',
  '--juslink-info-color-active': '#2b74d9',
  '--juslink-info-color-outline': 'rgba(64, 150, 255, 0.2)'
};

const juslinkCssVariables = {
  '--jusda-primary-color': '#FFC500',
  // 主色
  '--jusda-page-background-color': '#FFFFFF',
  // 页面基础背景色
  '--jusda-layout-background-color': '#F2F2F2',
  // 布局背景色
  '--jusda-primary-button-color': '#FFC500',
  // 主按钮色
  '--jusda-button-highlight-color': '#FFDA39',
  // 按钮高亮色
  '--jusda-primary-button-text-color': '#444444',
  // button①主按钮文字色
  '--jusda-background-white-text-secondary': '#EA9000',
  // 白底文字辅助色
  '--jusda-selected-background': '#FFF8D9',
  // 选中背景色
  '--jusda-slider-color': '#fcbe5b',
  // 滑块色
  '--jusda-slider-handle-color': '#fa8c16',
  // 滑块交互
  // '--jusda-ghost-button-hover-color': '#FFAA00',   // 幽灵按钮Hover
  '--jusda-button-click-color': '#FFE366',
  // 按钮点击色
  '--jusda-input-box-border-color': '#d9d9d9',
  // 一级框边框色（输入）
  '--jusda-input-focus-color': '#FFC500',
  // 输入框聚焦色
  '--jusda-outer-box-border-color': '#f0f0f0',
  // 二级框边框色（外框）
  '--jusda-tab-ghost-button-click-color': '#FFE366',
  // Tab、幽灵按钮点击
  '--jusda-top-border-color': '#CB9C00',
  // 顶部线条色
  '--jusda-divider-color': '#E9E9E9',
  // 常规分割线条色
  '--jusda-action-icon-color': '#F5AB00',
  // 列表内“操作列”icon色
  '--jusda-action-icon-hover-color': '#FFC500',
  // 列表内“操作列”icon Hover色
  '--jusda-success-color': '#6FC677',
  // 成功色
  '--jusda-warning-color': '#faad14',
  // 警戒色
  '--jusda-error-color': '#FF6C6C',
  // 错误色
  '--jusda-info-color': '#6294C6',
  // 信息色
  '--jusda-table-header-background-color': '#FFFBEA',
  // 表格表头背景色
  '--jusda-table-row-background-color': '#F9F9F9',
  // 表格间隔背景灰
  '--jusda-menu-collapse-background-color': '#CCCCCC',
  // 菜单底部收拉部底色
  '--jusda-secondary-button-hover-color': '#EA9000',
  // button②次要按钮Hover（灰色幽灵按钮）
  '--jusda-special-ghost-button-color': '#EA9000',
  // button③特殊幽灵按钮（彩色）
  '--jusda-special-ghost-button-hover-color': '#fcbe5b',
  // button③特殊幽灵按钮Hover（彩色）
  '--jusda-bottom-overlay-button-color': '#9B9B9B',
  // button④下方黑色浮层按钮（灰色幽灵）
  '--jusda-bottom-overlay-button-hover-color': '#FFC500',
  // button④下方黑色浮层按钮Hover（灰色幽灵）
  '--jusda-sidebar-menu-yellow-text-color': '#EA9000',
  // 左侧菜单黄色文字
  '--jusda-pagination-yellow-color': '#EA9000',
  // 页码黄色（文字）
  '--jusda-label-title-text-color': '#8D9AAD',
  // label标题色（文字）
  ...juslinkPackagecssVariables
};
const foxconnCssVariables = {
  '--jusda-primary-color': '#2755a6',
  // 主色
  '--jusda-page-background-color': '#FFFFFF',
  // 页面基础背景色
  '--jusda-layout-background-color': '#EAF0F5',
  // 布局背景色
  '--jusda-primary-button-color': '#2755a6',
  // 主按钮色
  '--jusda-button-highlight-color': '#0a71d8',
  // 按钮高亮色
  '--jusda-primary-button-text-color': '#FFFFFF',
  // button①主按钮文字色
  '--jusda-background-white-text-secondary': '#2755a6',
  // 白底文字辅助色
  '--jusda-selected-background': '#e1edf4',
  // 选中背景色
  '--jusda-slider-color': '#3e89d4',
  // 滑块色
  '--jusda-slider-handle-color': '#1677ff',
  // 滑块交互
  // '--jusda-ghost-button-hover-color': '#1677ff',   // 幽灵按钮Hover
  '--jusda-button-click-color': '#599eff',
  // 按钮点击色
  '--jusda-input-box-border-color': '#d9d9d9',
  // 一级框边框色（输入）
  '--jusda-input-focus-color': '#1677ff',
  // 输入框聚焦色
  '--jusda-outer-box-border-color': '#f0f0f0',
  // 二级框边框色（外框）
  '--jusda-tab-ghost-button-click-color': '#599eff',
  // Tab、幽灵按钮点击
  '--jusda-top-border-color': '#7D99C9',
  // 顶部线条色
  '--jusda-divider-color': '#E9E9E9',
  // 常规分割线条色
  '--jusda-action-icon-color': '#0a71d8',
  // 列表内“操作列”icon色
  '--jusda-action-icon-hover-color': '#358DE4',
  // 列表内“操作列”icon Hover色
  '--jusda-success-color': '#52c41a',
  // 成功色
  '--jusda-warning-color': '#faad14',
  // 警戒色
  '--jusda-error-color': '#ff3352',
  // 错误色
  '--jusda-info-color': '#1677ff',
  // 信息色
  '--jusda-table-header-background-color': '#F6FBFF',
  // 表格表头背景色
  '--jusda-table-row-background-color': '#F9F9F9',
  // 表格间隔背景灰
  '--jusda-menu-collapse-background-color': '#CCCCCC',
  // 菜单底部收拉部底色
  '--jusda-secondary-button-hover-color': '#2755a6',
  // button②次要按钮Hover（灰色幽灵按钮）
  '--jusda-special-ghost-button-color': '#2755a6',
  // button③特殊幽灵按钮（彩色）
  '--jusda-special-ghost-button-hover-color': '#0a71d8',
  // button③特殊幽灵按钮Hover（彩色）
  '--jusda-bottom-overlay-button-color': '9B9B9B',
  // button④下方黑色浮层按钮（灰色幽灵）
  '--jusda-bottom-overlay-button-hover-color': '#0a71d8',
  // button④下方黑色浮层按钮Hover（灰色幽灵）
  '--jusda-sidebar-menu-yellow-text-color': '#2755a6',
  // 左侧菜单黄色文字
  '--jusda-pagination-yellow-color': '#2755a6',
  // 页码黄色（文字）
  '--jusda-label-title-text-color': '#8D9AAD',
  // label标题色（文字）
  ...foxconnPackagecssVariables
};
function getCssVariables() {
  const cssVariables = isTms_1() ? foxconnCssVariables : juslinkCssVariables;
  return cssVariables;
}

function initBaseStyle() {
  const style = document.createElement('style');
  style.textContent = `
    ::selection {
        background-color: var(--jusda-primary-color) !important;
        color: white !important;
    }
    
    ::-moz-selection {
        background:var(--jusda-primary-color) !important;
        color:white !important;
    }
    
    ::-webkit-selection {
        background:var(--jusda-primary-color) !important;
        color:white !important;
    }
    `;
  document.head.appendChild(style);
}

/* eslint-disable @typescript-eslint/explicit-function-return-type */
function initCssVariables() {
  const cssVariables = getCssVariables();
  Object.entries(cssVariables).forEach(_ref => {
    let [property, value] = _ref;
    //@ts-ignore
    document.documentElement.style.setProperty(property, value);
  });
  initBaseStyle();
}

exports.getAntdConfig = getAntdConfig;
exports.initCssVariables = initCssVariables;
//# sourceMappingURL=index.js.map
